// Syncs the Kalü purchase radio options (variant + selling plan) into the
// hidden form inputs read by Dawn's product-form.js.

if (!customElements.get('kalu-purchase-options')) {
  class KaluPurchaseOptions extends HTMLElement {
    constructor() {
      super();
      this.onChange = this.onChange.bind(this);
    }

    connectedCallback() {
      this.form = this.closest('form');
      if (!this.form) return;
      this.variantInput = this.form.querySelector('.product-variant-id');
      this.planInput = this.form.querySelector('.product-selling-plan-id');
      this.addEventListener('change', this.onChange);
      this.syncFromCheckedRadio();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
    }

    onChange(event) {
      const target = event.target;
      if (!target || target.type !== 'radio' || target.name !== 'kalu-option') return;
      this.applyRadio(target);
    }

    syncFromCheckedRadio() {
      const checked = this.querySelector('input[name="kalu-option"]:checked');
      if (checked) this.applyRadio(checked);
    }

    applyRadio(radio) {
      const variantId = radio.dataset.variantId || '';
      const sellingPlanId = radio.dataset.sellingPlanId || '';
      if (this.variantInput) this.variantInput.value = variantId;
      if (this.planInput) this.planInput.value = sellingPlanId;
    }
  }
  customElements.define('kalu-purchase-options', KaluPurchaseOptions);
}
